export default {
    TipoDePeriodicidade: axios.create({
      baseURL: process.env.VUE_APP_ENDPOINT_API + "tipo-de-periodicidade"
    })
  }


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/TipoDePeriodicidade.js
// module id = 9ZHI
// module chunks = 32